import { createAsyncThunk } from "@reduxjs/toolkit";
import {  useGetData } from "../../../hooks/useGetData";
import notify from "../../../components/notify";
import i18n from "../../../i18n/i18n";

export const getRoomsForBooking = createAsyncThunk(
  "/roomSlice/getRoomsForBooking",
  async () => {
    try {
      const response = await useGetData(`/rooms/reception`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);

export const getOneRoom = createAsyncThunk(
  "/roomSlice/getOneRoom",
  async (id) => {
    try {
      const response = await useGetData(`/rooms/${id}`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);
export const getRoomsItems = createAsyncThunk(
  "/roomSlice/getRoomsItems",
  async (id) => {
    try {
      const response = await useGetData(`/ps-services`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);

